export const TOURNAMENT_NAME_ALLOWED_REGEXP = /[^0-9\u0400-\u04FF\s\-"'«»„“”’,.:()*&+[\\|/\]]/g;

export const TOURNAMENT_NAME_VALIDATION_REGEXP = /^[0-9\u0400-\u04FF\s\-"'«»„“”’,.:()*&+[\\|/\]]+$/;

export const sanitizeTournamentName = (value = '') =>
    value.replace(TOURNAMENT_NAME_ALLOWED_REGEXP, '');
